/**
 * Terminal Surface — a full-viewport, chrome-free interactive shell.
 *
 * Rendered outside AppShell (like /login), so it fills the whole screen and
 * installs as its own standalone PWA launcher via the manifest shortcut. The
 * shell is durable: the Terminal component reattaches to the same Shell session
 * by a persisted id, so backgrounding the PWA and coming back resumes it.
 */

import { Terminal } from "../components/terminal/Terminal";
import { X } from "lucide-react";

export function TerminalRoute() {
  return (
    <div className="fixed inset-0 h-[100dvh] w-screen flex flex-col bg-[var(--bw-bg)]">
      <div className="flex items-center gap-2 px-3 py-2 border-b border-[var(--bw-border)] shrink-0">
        <span className="text-xs uppercase tracking-wider text-[var(--bw-accent)]">
          Black Wall Terminal
        </span>
        <a
          href="/ops"
          aria-label="Close terminal"
          className="ml-auto text-[var(--bw-muted)] hover:text-[var(--bw-fg)] transition-colors"
        >
          <X size={18} />
        </a>
      </div>
      <div className="flex-1 min-h-0 p-1">
        <Terminal wsUrl="/api/terminal/ws" />
      </div>
    </div>
  );
}
